import AboutUsPage from "../pages/AboutUsPage";
import DeveloperProfilePage from "../pages/DeveloperProfilePage";
import FindJobsPage from "../pages/FindJobsPage";
import HireDeveloperPage from "../pages/HireDeveloperPage";
import OnboardingPage from "../pages/OnboardingPage";
import RegistrationPage from "../pages/RegistrationPage";

export const ROUTES = Object.freeze({
    HOME: '/',
    FIND_JOBS: '/find-jobs',
    SHARE_DEVELOPER: '/developer/:slug',
    ABOUT_US: '/about',
    HIRE_DEVELOPER: '/hire/skill/:slug',
    HIRE_ROLE: '/hire/role/:slug',
    START_HIRING: '/start-hiring',
})

const webRoutes = [
    {
        path: ROUTES.HOME,
        element: <OnboardingPage />, 
        isPrivate: false,
    },
    {
        path: ROUTES.FIND_JOBS,
        element: <FindJobsPage />,
        isPrivate: false,
    },
    {
        path: ROUTES.SHARE_DEVELOPER,
        element: <DeveloperProfilePage />, 
        isPrivate: false,
    },
    {
        path: ROUTES.ABOUT_US,
        element: <AboutUsPage />,
        isPrivate: false,
    },
    {
        path: ROUTES.HIRE_DEVELOPER,
        element: <HireDeveloperPage />,
        isPrivate: false,
    },
    {
        path: ROUTES.HIRE_ROLE,
        element: <HireDeveloperPage />,
        isPrivate: false,
    },
    {
        path: ROUTES.START_HIRING,
        element: <RegistrationPage />,
        isPrivate: false,
    },
]

export default webRoutes;